export const DEFAULT_DISMISS_TIMEOUT_MS = 8000;
export const DISMISS_TICK_MS = 100;
